import {BBModel} from "../bb_model";
import {Collection} from "./collection";

class SlotCollection extends Collection {

    constructor(resource, set) {
        super(resource, set);
        this.promise = new Promise((resolve, reject) => {
            return resource.$get('slots').then((slots) => {
                this.url = resource.$link('self').href;
                this.items = (Array.from(slots).map(slot => new BBModel.Admin.Slot(slot)));
                this.items.forEach(slot => set.updateItem(slot));
                this.total_entries = resource.total_entries;
                if (resource.start_date) this.start_date = moment(resource.start_date);
                if (resource.end_date) this.end_date = moment(resource.end_date);
                if (this.end_date) this.end_date.set({hour: 24, minute: 0});
                if (resource.company_id) this.company_id = resource.company_id;
                this.listenForPush(set);
                resolve(this);
            }, reject);
        });
    }

    checkParams(params) {
        if (params.end_time.diff(params.start_time, 'days') > 1) {
            return params.start_time.isBetween(this.start_date, this.end_date) ||
                   params.end_time.isBetween(this.start_date, this.end_date) ||
                   params.start_time.isSameOrBefore(this.start_date) &&
                       params.end_time.isSameOrAfter(this.end_date);
        } else {
            return params.start_time.isSame(this.start_date) ||
                params.start_time.isBetween(this.start_date, this.end_date);
        }
    }

    updateOrAddSlot(newSlot) {
        const index = this.findIndex(newSlot.id);
        if (this.start_date && this.end_date) {
            const params = {
                start_time: moment(newSlot.datetime),
                end_time: moment(newSlot.end_datetime)
            }
            if (this.checkParams(params)) {
                this.updateItem(newSlot);
            } else {
                if (index > -1) {
                    this.items.splice(index, 1);
                    this.callListeners(newSlot, 'destroy');
                }
            }
        }
    }

    handlePush(push) {
        if (push.action === 'destroy') {
            this.pushDelete(push);
        } else {
            const newSlot = push.object;
            if (newSlot.status === BBModel.Admin.Slot.HELD) {
                // Ignore held items
                return;
            } else if (newSlot.status === BBModel.Admin.Slot.AVAILABLE && !newSlot.$has('event')) {
                // Remove slot if not event and status is available
                const index = this.findIndex(newSlot.id);
                if (index > -1) this.items.splice(index, 1);
                this.callListeners();
            } else if (this.start_date && this.end_date) {
                switch (push.action) {
                    case 'create':
                        this.updateOrAddSlot(newSlot);
                        break;
                    case 'update':
                        this.updateOrAddSlot(newSlot);
                        break;
                }
            } else {
                console.log('flush');
                // TODO: maybe refetch instead of flush
                // do we need to flush all paginated collections?
                // delete collections[this.url];
            }
        }
    }

    static $query(set, company, params) {
        // TODO: If the following params are not set on the request, the api will set them by default and include them
        // in the self link within response. Therefore we must include them so sets/collections cache urls match.
        if (params.page == null) params.page = 1;
        if (params.per_page == null) params.per_page = 100;
        if (params.include_booking_details == null) params.include_booking_details = false;
        if (params.include_event_details == null) params.include_event_details = false;

        return super.$query(SlotCollection, set, company, params);
    }

}

SlotCollection.group = 'slots';

export {
    SlotCollection
}

